(() => {
  const homePage = document.querySelector('.node--type-home-page');

  if (homePage) {
    const contentOffset = document.querySelector('.region-content').offsetTop;
    const homePageSectionsBlock = document.getElementById(
      'block-opinions-views-block-home-page-sections-menu',
    );
    const homePageSectionPositions = new Map();
    let homePageSectionsMenuLinks = [];
    let homePageSections = null;
    let scrolledAmount = 0;
    let sectionNavId;
    let scrollPosition;
    let requestedFrame = false;

    if (homePageSectionsBlock !== null) {
      homePageSectionsMenuLinks =
        homePageSectionsBlock.getElementsByClassName('menu-item__link');
      // If not found, will return null
      homePageSections = document
        .querySelector('#block-opinions-content')
        .querySelectorAll('.field--name-field-section-title');
    }
    if (homePageSections !== null) {
      homePageSections.forEach((section) => {
        sectionNavId = `${section.id}Nav`;
        scrollPosition =
          section.getBoundingClientRect().top -
          document.body.getBoundingClientRect().top;
        homePageSectionPositions.set(sectionNavId, scrollPosition);
      });
    }
    const removeActiveMenu = (menuLinks) => {
      Array.from(menuLinks).forEach((menuLink) => {
        menuLink.classList.remove('active');
      });
    };
    const updateSideMenu = (scrolledPos) => {
      homePageSectionPositions.forEach((position, section) => {
        if (position - contentOffset <= 100) {
          removeActiveMenu(homePageSectionsMenuLinks);
          document.getElementById(section).classList.add('active');
        } else if (position - scrolledPos <= 100) {
          removeActiveMenu(homePageSectionsMenuLinks);
          document.getElementById(section).classList.add('active');
        }
      });
    };

    window.addEventListener('load', () => {
      scrolledAmount = window.scrollY;
      updateSideMenu(scrolledAmount);
    });
    window.addEventListener('scroll', () => {
      scrolledAmount = window.scrollY;
      if (!requestedFrame) {
        window.requestAnimationFrame(() => {
          updateSideMenu(scrolledAmount);
          requestedFrame = false;
        });
      }
      requestedFrame = true;
    });
  }
})();
